import { useState } from 'react'
import { useCorpSettingStore, useCorpInfoStore } from '@/stores'
import { useParams, useSearchParams } from 'react-router-dom'
import { common, storageUtil, utils } from '@/utils'
import { useMount } from 'ahooks'
import i18n from '@/utils/i18n'

const { onTempLogin, getCorpSetting } = common
const { setLocalStorage, getLocalStorage } = storageUtil
const { isWebview } = utils

function RouterGuardTempLogin({ children }: any) {
  const { corpSetting, setCorpSetting } = useCorpSettingStore()
  const { corpInfo } = useCorpInfoStore()
  const [loginStatus, setLoginStatus] = useState(false)
  const lang2I18nMap: any = {
    zh: 'zh-CN',
    en: 'en-US',
    vi: 'vi-VN',
    'zh-TW': 'zh-TW',
  }
  const [searchParams] = useSearchParams()
  const { corpId } = useParams() as Record<string, string>

  useMount(async () => {
    const tempToken = sessionStorage.getItem('tempToken')
    const { corpId: corpIdInStore } = corpInfo || {}
    if (!tempToken || corpId !== corpIdInStore) {
      await onTempLogin(corpId)
    }

    // 设置语言
    async function setLang(lang: string) {
      i18n.changeLanguage(lang)
      corpSetting.language = lang
      setCorpSetting(corpSetting)
      setLocalStorage('language', lang)
      // 获取企业设置，更新企业地址
      await getCorpSetting()
    }

    function handleGetAppLang() {
      let lang = 'en'
      if (
        window.webview?.getAuth &&
        typeof window.webview?.getAuth === 'function'
      ) {
        const authInfo = JSON.parse(window.webview.getAuth())
        lang = authInfo.language
      }
      if (searchParams.get('lang')) {
        lang = searchParams.get('lang') || 'en'
      }

      return lang
    }

    // 转换语言格式
    function formateLang(lang: string = 'en') {
      // 如果是下划线的语言，转成横杠
      if (lang.includes('_')) {
        lang = lang.replace('_', '-')
        // 如果是非下划线，非横杠的语言，用map匹配
      } else if (!lang.includes('-')) {
        lang = lang2I18nMap[lang]
      }

      // 横杠的语言，直接返回
      return lang
    }

    // 如果是webview就拿app传的语言
    let lang =
      (isWebview() ? handleGetAppLang() : getLocalStorage('language')) || 'en'
    lang = formateLang(lang)
    await setLang(lang)

    // 获取staffId
    if (isWebview()) {
      const authInfo = JSON.parse(window.webview.getAuth())
      const { staffId } = authInfo
      setLocalStorage('staffId', staffId)
    }

    setLoginStatus(true)
  })

  // 游客登录成功后，正常渲染
  return <>{loginStatus ? children : null}</>
}

export default RouterGuardTempLogin
